import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-message-icon',
  templateUrl: './message-icon.component.html',
  styleUrls: ['./message-icon.component.scss'],
  standalone: false
})
export class MessageIconComponent {
  @Input() messageLevel: number;
}
